import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/slcp/(pages)')({
  beforeLoad: ({ location }) => {
    const path = location.pathname.replace(/\/$/, '');
    // /slcp and /slcp/assessments are not real pages — both are
    // breadcrumb anchors. Send the user to the default list view.
    if (path === '/slcp' || path === '/slcp/assessments') {
      throw redirect({ to: '/slcp/my-own/active' });
    }
  },
});
